module.exports = __webpack_public_path__ + "static/media/sidebar-school-active.bae8d13b.svg";